export default "__VITE_ASSET__CBRRh$LF__"